import { Box, HStack, Input } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import CustomButton from "../../../components/atoms/CustomButton/CustomButton";
import { getFetchQuestionByID } from "../../../network/LearnApiService";
import { usePractice } from "../../../context/PracticeContext";
import { useTutor } from "../../../context/AiTutorContext";
import { FaInfoCircle } from "react-icons/fa";
import { handleNavigateFeeback } from "../../../utils/TutorConstants";

import { useRoot } from "../../../context/RootContext";
import { useNavigate } from "@remix-run/react";
import { tutorString } from "../../../utils/common-utils";

export default function PracticeByQuestion(props) {
  const navigate = useNavigate();
  const { handleSetCurriculumDetails } = useTutor();
  const { handleExtraAndStoreImages, setDisplayedQues, resetPractice, setCurrentQuestionIndex,
    questionID, setQuestionID, currentQuesIndex, chatHistory } = usePractice();
  const { isStandalone, setRubricInfo, playgroundMode } = useRoot();
  useEffect(() => {
    resetPractice();
    if (!isStandalone) {
      navigate(tutorString + "/practice");
    }
  }, [playgroundMode]);
  const handleFetchQuestion = async () => {
    let { success, data } = await getFetchQuestionByID(questionID);
    if (success) {
      setCurrentQuestionIndex(0);
      const quesObj = data?.results?.[0];
      const { rubric = {} } = quesObj;
      handleSetCurriculumDetails(quesObj?.syllabusMapping?.[0]);
      setDisplayedQues(data?.results);
      handleExtraAndStoreImages(quesObj, 0);
      const { _id, rubricId, rubricType, name: rubricName } = rubric;
      setRubricInfo({
        rubricID: rubricId || _id,
        rubricName: rubricName,
        rubricType: rubricType,
        subjectID: quesObj?.subjects?.[0],
        topicDetails: quesObj?.syllabusMapping?.[0],
      });
    }
  };
  let currentChat = chatHistory?.[currentQuesIndex] || [];
  return (
    <Box position={"relative"}>
      {props?.isPlayground && currentChat?.length > 0 && (
        <Box position={"absolute"} right={2} top={2} zIndex={1000}>
          <FaInfoCircle
            cursor={"pointer"}
            onClick={() => { handleNavigateFeeback(props?.chatId) }}
            size={24}
          />
        </Box>
      )}
      <HStack mb={2} pointerEvents={currentQuesIndex != -1 ? "none" : "auto"}>
        <Input
          placeholder="Question ID"
          value={questionID}
          onChange={(e) => {
            setQuestionID(e.target.value);
          }}
          w={"360px"}
          borderColor={"#c7bcfe"}
        />
        <CustomButton
          image={undefined}
          label={`Submit`}
          handleClick={handleFetchQuestion}
        />
      </HStack>
    </Box>
  );
}
